// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d96a1951","455":"fc9abf77"}[chunkId] + ".chunk.js";
};